export default __webpack_public_path__ + "static/media/feature_image_5.4281ce34.webp";